import { CardBrand, humanizeCardBrand } from '../../interfaces/cardBrand';

export const getHumanizeCardBrand = (cardBrand?: CardBrand) => {
  if (!cardBrand) {
    return null;
  }

  return humanizeCardBrand[cardBrand] || cardBrand;
};
